module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_int_01_6DB79_1SB_H2G.f3281b47.jpg";